import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import videoBg from "../assets/landing-hero-short.mp4";
import slogan from "../assets/learn_dance_connect_nobg.png";
import { useEffect, useState } from "react";

const HERO_POSTER = "/hero-poster.jpg";

const Hero = () => {
  const navigate = useNavigate(); // Hook for navigation
  const [showUI, setShowUI] = useState(false); // Set to true to show the UI elements, false to hide them
  const [videoReady, setVideoReady] = useState(false); // Fades the video in once it can actually play

  const routeChange = (path) => {

    navigate(path);
  };
  const scrollToBottom = () => {
    setTimeout(() => {
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    }, 0);
  };

  useEffect(() => {
    setTimeout(() => {
      setShowUI(true);
    }, 3500); // Delay of 1.2 seconds before showing the UI elements        
    }, []);

  return (
    <Wrapper>

       <div className="overlay"></div>

      <div
        className="videoWrap"
        style={{ backgroundImage: `url(${HERO_POSTER})` }}
      >
        <video
          className={`fg${videoReady ? " ready" : ""}`}
          src={videoBg}
          poster={HERO_POSTER}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          onCanPlay={() => setVideoReady(true)}
        ></video>
      </div>
      <div className="control">{/* <h1> sound</h1>*/}</div>

      {showUI && (
        
        <div className="content">
          <section id="slogan">
            <img src={slogan} alt="slogan" />
          </section>
          <div className="btnContainer">
          <button onClick={() => routeChange('why')} className="btn">
            Who are we?
          </button>
          <button onClick={() => routeChange('contact')} className="btn2">
            Ask us anything
          </button>
        </div>  
        </div>
      
      )}
      
     
      
    </Wrapper>
  );
};

const Wrapper = styled.section`
  height: 100vh;
  overflow: hidden;
  position: relative;
  background-color: #635655;

  .videoWrap {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: 50% 30%;
  }
  .control {
    position: absolute;
    top: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
  }
  .content {
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #fff;
    opacity: 0;
    animation: fadeIn 1.2s ease forwards;
  }
  .btnContainer {
    display: flex;
    gap: 1.2rem;
    justify-content: center;
    align-items: center;
    margin-top: 2rem;
  }
  .overlay {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
    background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.65) 0%,
      rgba(0, 0, 0, 0.45) 45%,
      rgba(0, 0, 0, 0.35) 100%
    );
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(15px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  video {
      position: absolute;
      inset: 0;
  }

  .fg {
    width: 100%;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
    object-fit: cover; /* shows more of the frame */
    object-position: 50% 30%;
    opacity: 0;
    transition: opacity 0.5s ease;
  }
  .fg.ready {
    opacity: 1;
  }
  #dancer1 img {
    position: absolute;
    bottom: 0%;
    left: 1%;
    height: 10rem;
  }
  #dancer2 img {
    position: absolute;
    bottom: 0%;
    right: -0%;
    height: 12rem;
  }
  #slogan {
    height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #slogan img {
    height: auto;
    max-width: 80%;
    object-fit: contain;
  }
  .content button {
    position: relative;
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    border: 2px solid var(--clr-primary-2);
    border-radius: 50px;
    padding: 0.8rem 2rem;
    font-size: 1.05rem;
    letter-spacing: 0.5px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 0 12px rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(4px);
  }
  .content button:hover {
    background: linear-gradient(135deg, var(--clr-primary-2), #ff6ec7);
    color: #fff;
    box-shadow: 0 0 25px rgba(255, 105, 180, 0.6),
      0 0 8px rgba(255, 255, 255, 0.3);
    transform: translateY(-3px);
  }

  .content .btn2 {
    background: linear-gradient(135deg, #fff, #f8f8f8);
    color: #111;
    border: 2px solid #fff;
    box-shadow: 0 0 18px rgba(255, 255, 255, 0.4);
    opacity: 0.95;
    font-weight: 600;
    transition: all 0.3s ease;
  }
  .content .btn2:hover {
    background: linear-gradient(135deg, #ff6ec7, var(--clr-primary-2));
    color: #fff;
    box-shadow: 0 0 30px rgba(255, 105, 180, 0.6),
      0 0 12px rgba(255, 255, 255, 0.3);
    transform: translateY(-3px);
  }
  #cta {
    height: 20vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media (min-width: 667px) {
    #dancer1 img {
      height: 15rem;
    }
    #dancer2 img {
      height: 20rem;
    }
    #slogan img {
      height: 20vh;
    }
  }

  @media (min-width: 992px) {
    /* grid-template-columns: 1fr 1fr;
        gap: 8rem; */
    #slogan img {
      height: 30vh;
    }
    #dancer1 img {
      height: 20rem;
    }
    #dancer2 img {
      height: 25rem;
    }
    .BCBackground {
      background: url("CUTBachataBackground.png");
      background-size: cover;
      /* background-position: left 10% bottom 20%; */
      background-repeat: no-repeat;
      background-origin: border-box;
      background-clip: border-box;
      width: 100vw;
      height: 50vh;
      position: relative;
    }
    .BCVideo {
      /* background: url('BCShortVideo-higher.gif'); */
      background-size: cover;
      /* background-position: left 10% bottom 20%; */
      background-repeat: no-repeat;
      background-origin: border-box;
      background-clip: border-box;
      width: 100vw;
      height: 50vh;
      background-position: center;
      /* height: 100vh; */
      height: 100vh;
    }
    h1 {
      margin-bottom: 2rem;
    }
    p {
      font-size: 1.25rem;
    }
  }
`;

export default Hero;
